import PropTypes from 'prop-types';
import { EventBus } from 'use-event-bus-hook';
// Components
import Entity from '../../entity/Entity';
import Icon from '../../icon/Icon';
import TooltipHelper from '@/common-utils/components/renders/tooltip/TooltipHelper';
// Common
import ICONS from '@/common-utils/enums/icons';
import TABLE_CONSTANTS from '../enums/Constants';
import DATA_TABLE_EVENT_BUS_NAMES from '../enums/DataTableEventBusNames';
import createDataCyAttribute from '@/common-utils/functions/createDataCyAttribute';
// Styles
import './Header.scss';
/**
 * @param root0
 * @param root0.column
 * @param root0.query
 * @param root0.setQuery
 * @param root0.queryStored
 * @param root0.storeQuery
 * @param root0.setLaunchRefetch
 * @param root0.tooltip
 * @param root0.namespace
 * @param root0.filtersEventName
 * @returns {JSX} Header
 */
function Header({ column, query, setQuery, storeQuery = () => { }, setLaunchRefetch, tooltip, namespace, filtersEventName }) {

    const hiddenFilterKeys = new Set((query.filters ?? []).filter(f => f.hidden).map(f => f.key));
    const isFilterable = column.columnDef.filter && !hiddenFilterKeys.has(column.id);
    const sortDescFirst = column.columnDef.sortDescFirst === true;
    const queryOrders = query.orders ?? [];
    const currentOrder = queryOrders.find(order => order.key === column.id);
    // 0 = ASC, 1 = DESC, 2 = not sorted
    const orderIcon = !currentOrder ? 2 : (currentOrder.desc ? 1 : 0);

    const updateQueryOrders = () => {
        // enableSorting: true
        if (column.getCanSort()) {
            const indexOrderToUpdate = queryOrders.findIndex(order => order.key === column.id);
            let updatedOrder = {};
            if (indexOrderToUpdate === -1) {
                // First click: DESC for date columns, ASC otherwise
                updatedOrder = [...queryOrders, { key: column.id, desc: sortDescFirst }];
            } else {
                // If order already exists, update it
                const oldOrderToUpdate = queryOrders[indexOrderToUpdate];
                if (oldOrderToUpdate.desc === sortDescFirst) {
                    // Switch to opposite direction
                    // If already on DESC, switch to ASC and vice versa
                    updatedOrder = [...queryOrders.slice(0, indexOrderToUpdate), { key: column.id, desc: !sortDescFirst }, ...queryOrders.slice(indexOrderToUpdate + 1)];
                } else {
                    // Remove sort order
                    updatedOrder = [...queryOrders.slice(0, indexOrderToUpdate), ...queryOrders.slice(indexOrderToUpdate + 1)];
                }
            }
            setQuery({
                offset: TABLE_CONSTANTS.OFFSET_STARTING_VALUE,
                limit: TABLE_CONSTANTS.ROWS_NUMBER_PER_PAGE,
                orders: updatedOrder,
                filters: query.filters
            });
            storeQuery({
                offset: TABLE_CONSTANTS.OFFSET_STARTING_VALUE,
                limit: TABLE_CONSTANTS.ROWS_NUMBER_PER_PAGE,
                orders: updatedOrder,
                filters: query.filters
            });
            setLaunchRefetch(true);
        }
    };

    return (
        <div
            className='rt-table-cust-header text-labelGray-foreground bg-transparent border-none p-0 m-0 space-x-1'
        >
            <Entity
                nowrap
                entity={column.columnDef.entity}
                namespace={column.columnDef.namespace}
                icon={isFilterable ? ICONS.FILTER : undefined}
                onClick={() => {
                    if (isFilterable) {
                        EventBus.emit(DATA_TABLE_EVENT_BUS_NAMES.OPEN_FILTER, { ...column.columnDef, filterEventName: filtersEventName });
                    }
                }}
                className={isFilterable ? 'cursor-pointer' : undefined}
                alternativeDataCy={createDataCyAttribute(column.id)}
                iconSize={16}
            />
            {
                tooltip && namespace &&
                <TooltipHelper
                    trigger={<Icon icon={ICONS.HELP} />}
                    content={<Entity
                        entity={tooltip}
                        namespace={namespace}
                    />}
                    contentClass={'max-w-80 text-center'}
                />
            }
            {
                column.getCanSort() &&
                <span className='sort-icons cursor-pointer' onClick={updateQueryOrders}>
                    {
                        orderIcon === 0 &&
                        <Icon icon={ICONS.CHEVRON_UP} strokeWidth={3} size={16} />
                    }
                    {
                        orderIcon === 1 &&
                        <Icon icon={ICONS.CHEVRON_DOWN} strokeWidth={3} size={16} />
                    }
                    {
                        orderIcon === 2 &&
                        <span className='not-sorted space-y-[10px]'>
                            <Icon icon={ICONS.CHEVRON_UP} className={'order-icon-height'} strokeWidth={3} size={16} />
                            <Icon className='icon-down' icon={ICONS.CHEVRON_DOWN} strokeWidth={3} size={16} />
                        </span>
                    }
                </span>
            }
        </div>
    );
}

Header.propTypes = {
    column: PropTypes.object.isRequired,
    query: PropTypes.object.isRequired,
    setQuery: PropTypes.func.isRequired,
    setLaunchRefetch: PropTypes.func.isRequired,
    queryStored: PropTypes.object,
    storeQuery: PropTypes.func,
    tooltip: PropTypes.string,
    namespace: PropTypes.string,
    filtersEventName: PropTypes.string
};
export default Header;